var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_1220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 16.5H8.01207C6.45139 16.4993 4.92501 16.042 3.62094 15.1847C2.31687 14.3273 1.29206 13.1072 0.672737 11.6746C0.0534139 10.2421 -0.133372 8.65971 0.135386 7.12235C0.404144 5.58499 1.11671 4.15981 2.18531 3.02236C3.25391 1.88491 4.63188 1.08486 6.14949 0.720759C7.6671 0.356657 9.25807 0.444403 10.7264 0.97319C12.1948 1.50198 13.4764 2.44871 14.4135 3.69678C15.3505 4.94485 15.902 6.43974 16.0001 7.99733V8.03933V16.5ZM8.01207 1.83333C6.24396 1.83333 4.54826 2.53571 3.29802 3.78596C2.04778 5.0362 1.3454 6.73189 1.3454 8.5C1.3454 10.2681 2.04778 11.9638 3.29802 13.214C4.54826 14.4643 6.24396 15.1667 8.01207 15.1667H14.6667V8.06067C14.5524 6.37288 13.8019 4.79135 12.5667 3.63549C11.3315 2.47962 9.70372 1.83555 8.01207 1.83333Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66748 5.16653H4.66748V6.49987H8.66748V5.16653Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3341 7.8335H4.66748V9.16684H11.3341V7.8335Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3341 10.5001H4.66748V11.8334H11.3341V10.5001Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_1220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.cdd0ff4aa4147b86a53fd9f7fc438b8a.svg";
export { ForwardRef as ReactComponent };